import React from "react";
import Typography from "@common/components/Typography";
import { TFunction } from "react-i18next";
import { ElogParticipant } from "@services/meetings/types";
import IconButton from "@common/components/IconButton";
import { EditRounded } from "@mui/icons-material";
import { displayDateTime } from "@common/utils/localTime.utils";
export const getColumns = (
  onParticipantEdit: (id: number) => void,
  t: TFunction
): ColDef<ElogParticipant>[] => [
  {
    sortable: false,
    label: "Start Time",
    key: "connectTime",
    render: ({ connectTime }) => (
      <Typography
        size="small"
        sx={{
          textAlign: "center",
        }}
      >
        {displayDateTime(connectTime)}
      </Typography>
    ),
  },
  {
    sortable: false,
    label: "End Time",
    key: "disconnectTime",
    render: ({ disconnectTime }) => (
      <Typography
        size="small"
        sx={{
          textAlign: "center",
        }}
      >
        {displayDateTime(disconnectTime)}
      </Typography>
    ),
  },
  {
    sortable: false,
    label: "Room",
    key: "room",
    width: 130,
    render: ({ room }) => (
      <Typography
        size="small"
        sx={{
          textAlign: "center",
        }}
      >
        {room?.name ?? ""}
      </Typography>
    ),
  },
  {
    sortable: false,
    label: "Device",
    key: "device",
    render: ({ device }) => (
      <Typography
        size="small"
        sx={{
          textAlign: "center",
        }}
      >
        {device?.name ?? ""}
      </Typography>
    ),
  },
  {
    sortable: false,
    label: "Address",
    key: "address",
    render: ({ address }) => (
      <Typography
        size="small"
        sx={{
          textAlign: "center",
        }}
      >
        {address ?? ""}
      </Typography>
    ),
  },
  {
    sortable: false,
    label: "",
    key: "id",
    render: ({ id }) => (
      <IconButton color="primary" onClick={() => onParticipantEdit(id)}>
        <EditRounded />
      </IconButton>
    ),
  },
];
